import React from 'react';
import PropTypes from 'prop-types';

import { publishBanner, unpublishBanner } from '../../../../services/lwadmin/homepage/banner-service';
import { Link, RowContainer } from '../../shared/styles';
import { ActionColumn, NameColumn } from './styles';

export default function Banner({ banner }) {
  const {
    id,
    name,
    published,
    publishable,
  } = banner;

  const [isPublished, setIsPublished] = React.useState(published);

  const publish = e => {
    e && e.preventDefault();

    publishBanner(id).then(() => setIsPublished(true));
  };

  const unpublish = e => {
    e && e.preventDefault();

    unpublishBanner(id).then(() => setIsPublished(false));
  };

  return (
    <RowContainer>
      <NameColumn>{name}</NameColumn>
      <ActionColumn>
        <Link href={`/lwadmin/homepage/banner/${id}/edit`}>Edit</Link>
        {(isPublished || publishable) && (
          <>
            |
            {isPublished && <Link href="#" onClick={unpublish}>Unpublish</Link>}
            {!isPublished && publishable && <Link href="#" onClick={publish}>Publish</Link>}
          </>
        )}
      </ActionColumn>
    </RowContainer>
  );
}

Banner.propTypes = {
  banner: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    published: PropTypes.bool.isRequired,
    publishable: PropTypes.bool.isRequired,
  }).isRequired,
};
